import React from 'react'
import bgImage from '../../assets/servicesImages/ds/hero.png'
import pic1 from '../../assets/servicesImages/ds/1.png'
import pic2 from '../../assets/servicesImages/ds/2.png'
import pic3 from '../../assets/servicesImages/ds/3.png'
import pic4 from '../../assets/servicesImages/ds/4.png'
import benefits from '../../assets/servicesImages/ds/benefits.png'
import imagea from '../../assets/servicesImages/ai/a.png'
import Slider from 'react-slick'
import arrow from '../../assets/viewdetails.png'

const items = [
  {
    image: imagea,
    desc: 'Expertise: Our team comprises experienced AI professionals with deep knowledge across various industries.'
  },
  {
    image: imagea,
    desc: 'Sales & Purchase Management: Increase productivity & lower costs by managing your full cycle from purchases to sales orders.'
  },
  {
    image: imagea,
    desc: 'Custom AI Solutions: We tailor AI strategies and tools that align with your specific business goals.'
  }
]

const cards = [
  {
    image: pic1,
    title: 'Data Science Consulting Services & Solutions',
    desc: 'Expertise: Our team comprises experienced AI professionals with deep knowledge across various industries.'
  },
  {
    image: pic2,
    title: 'Data Preparation',
    desc: 'Our experts enrich data sets by replacing missing values, analyzing outliers, and defining categorical variables.'
  },
  {
    image: pic3,
    title: 'Model Generation',
    desc: 'Our engineers build, test, and refine data science models to achieve impactful outcomes.'
  },
  {
    image: pic4,
    title: 'Migration',
    desc: 'We offer cross-platform migration of algorithms to extend your solution’s reach and flexibility.'
  }
]

const settings = {
  className: 'center',
  centerMode: true,
  infinite: true,
  slidesToShow: 3,
  speed: 500,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
        breakpoint: 3000, // large screens default
        settings: {
            slidesToShow: 4,
        },
    },
    {
        breakpoint: 1024, // md to lg
        settings: {
            slidesToShow: 2.5,
            centerMode: false,
        },
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            centerMode: false,
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            centerMode: false,
        }
    }
]
};

const DS = () => {
  return (
    <div className='flex flex-col gap-[64px]'>
      {/* HERO SECTION */}
      <div className='h-[40vh] md:h-[50vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className='absolute inset-0 bg-[rgba(89,119,221,0.15)] z-0'></div>
        <div className='flex flex-col gap-12 px-6 py-16 sm:px-10 md:px-20 lg:px-28 z-10'>
  <div className='flex flex-col gap-8'>
    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-snug sm:leading-tight md:leading-[1.2]">
      Data Science Consulting Services
    </h1>
    <p className='text-base sm:text-lg max-w-[500px] font-normal leading-relaxed sm:leading-[26px] text-left'>
      AI software development transforms data into intelligence, automating tasks and driving innovation in various industries.
    </p>
  </div>
</div>

      </div>

      {/* INTRO PARAGRAPH */}
      <div className='flex flex-col gap-9 px-4 sm:px-8 md:px-20 lg:px-28'>
  <p className='text-center text-2xl sm:text-3xl md:text-4xl font-semibold leading-snug sm:leading-[42px]'>
    Data Science Consulting Services
  </p>
  <p className='text-sm sm:text-base md:text-lg leading-relaxed sm:leading-[26px] text-justify text-gray-700'>
    At Esparse Matrix Solutions, we offer comprehensive data science consulting services designed to help businesses harness the power of data to drive growth, optimize operations, and gain a competitive edge. Our team of experienced data scientists and analysts work closely with you to develop tailored solutions that meet your unique business needs.
  </p>
</div>

{/* SERVICES CARDS SECTION */}
<div className='flex flex-col gap-9 px-4 sm:px-8 md:px-20 lg:px-28 mt-10'>
  <p className='text-center text-2xl sm:text-3xl md:text-4xl font-semibold leading-snug sm:leading-[42px]'>
    Our Data Science & Consulting Services
  </p>

  <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8'>
    {cards.map((item, index) => (
      <div
        key={index}
        className='flex flex-col items-center bg-white rounded-xl shadow-md p-5 h-full group transition-all duration-300 hover:shadow-2xl hover:scale-[1.03]'
      >
        <img
          src={item.image}
          alt='service'
          className='w-full h-[160px] object-contain mb-4 transition-transform duration-300 group-hover:scale-105'
        />
        <h3 className='text-[18px] font-bold text-center mb-2 transition-colors duration-300 group-hover:text-[#0058AE]'>
          {item.title}
        </h3>
        <p className='text-[15px] text-gray-600 text-justify transition-colors duration-300 group-hover:text-gray-800'>
          {item.desc}
        </p>
      </div>
    ))}
  </div>
</div>


      {/* BENEFITS SECTION */}
      <div className='flex flex-col gap-[36px] px-6 md:px-28'>
      <p className='text-center text-2xl sm:text-3xl md:text-4xl font-semibold leading-snug sm:leading-[42px]'>
  Benefits of Our Data Science & Consulting Services
</p>

        <div className='flex flex-col lg:flex-row gap-10 items-center'>
          <img
            src={benefits}
            alt='benefits'
            className='w-full lg:w-[40%] max-h-[400px] object-contain rounded-xl'
          />
          <ul className='flex flex-col gap-6 text-[18px] w-full'>
            <li>
              <span className='font-semibold text-[#0058AE] text-[20px]'>
                Informed Decision Making:
              </span>{' '}
              Leverage data-driven insights to make strategic decisions.
            </li>
            <li>
              <span className='font-semibold text-[#0058AE] text-[20px]'>
                Enhanced Efficiency:
              </span>{' '}
              Streamline operations and improve productivity through automation.
            </li>
            <li>
              <span className='font-semibold text-[#0058AE] text-[20px]'>
                Competitive Advantage:
              </span>{' '}
              Stay ahead using advanced analytics and techniques.
            </li>
            <li>
              <span className='font-semibold text-[#0058AE] text-[20px]'>
                Scalability:
              </span>{' '}
              Scalable solutions that grow with your business.
            </li>
          </ul>
        </div>
      </div>

      {/* WHY CHOOSE US */}
      <div className='px-6 md:px-28'>
  <p className='text-center text-[32px] font-semibold leading-[40px] mb-16'>
    Why Choose Esparse Matrix Solutions?
  </p>

  <Slider {...settings} className='overflow-hidden'>
    {items.map((item, index) => (
      <div key={index} className='px-4'>
        <div className='bg-white rounded-xl p-6 h-full shadow-lg hover:shadow-2xl transition-all duration-300 group'>
          <div className='flex flex-col items-center gap-6'>
            <div className='w-[120px] h-[120px] overflow-hidden rounded-full border-2 border-[#0058AE]'>
              <img
                src={item.image}
                alt='icon'
                className='w-full h-full object-contain transition-transform duration-300 group-hover:scale-110'
              />
            </div>
            <p className='text-gray-700 text-[16px] text-center leading-[24px]'>
              {item.desc}
            </p>
          </div>
          <div className='flex justify-center items-center mt-6 text-[#0058AE] text-sm font-medium gap-1'>
            <a href='/' className='hover:underline'>
              View Details
            </a>
            <img src={arrow} alt='arrow' className='w-[12px]' />
          </div>
        </div>
      </div>
    ))}
  </Slider>
</div>

    </div>
  )
}

export default DS
